import { useSelector } from 'react-redux';
import { getGeneralInfo } from '@/store/account/actions';

export const useAccountTrusted = (): boolean => {
    const generalInfo = useSelector(getGeneralInfo);
    return generalInfo?.IsTrusted;
};
